export const GUARANTEES = {
  CASH: 'cash',
  VEHICLE: "vehicle",
  LAND: "land"
}